import React from 'react'
import Carousel from '../components/Carousel/Carousel'
import Explore from '../components/Explore/Explore'
import client from '../sanityClient'



export default function Home(props) {

    const setTitle = props.setTitle;
    const setProgress = props.setProgress;

    React.useEffect(() => {
        setTitle("Academic Outreach and New Initiatives | IIT Delhi")
        setProgress(100);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [images, setImages] = React.useState([]);

    React.useEffect(() => {
        // Fetch images from the Sanity CMS
        client.fetch(`*[_type == "carouselImage"] | order(position asc){
            "src": image.asset->url,
            position
        }`).then((data) => setImages(data));
    }, []);

    return (
        <>
            <Carousel images={images} title="Welcome to" heading="Academic Outreach@IITD" />
            <Explore />
        </>
    )
}
